import type { SunglassesPageConfig, FaqItem } from './types';

/** 默认商品分组 ID（兜底用） */
export const DEFAULT_GROUP_ID = 81;

/** 每页商品数量 */
export const PAGE_SIZE = 36;

/** hreflang 配置 */
export const HREFLANG_MAP: Record<string, string> = {
  en: 'https://www.zeelool.com/campaigns/sunglasses-sale',
  'x-default': 'https://www.zeelool.com/campaigns/sunglasses-sale',
  'en-US': 'https://www.zeelool.com/campaigns/sunglasses-sale',
  de: 'https://de.zeelool.com/campaigns/sunglasses-sale',
  fr: 'https://fr.zeelool.com/campaigns/sunglasses-sale',
  'en-CA': 'https://ca.zeelool.com/campaigns/sunglasses-sale',
  'en-GB': 'https://uk.zeelool.com/campaigns/sunglasses-sale',
};

/** 获取当前导航选中的 group_id（用于 SSR） */
export function getDefaultGroupId(config: SunglassesPageConfig): number {
  const primary = config.navigation.wap[0];
  const defaultSecondary = primary?.secondaryNav.find((s) => s.isDefault);
  return defaultSecondary?.groupId || primary?.secondaryNav[0]?.groupId || DEFAULT_GROUP_ID;
}

/** 获取默认二级导航的 H1 和 FAQ（用于 SSR） */
export function getDefaultSecondaryConfig(config: SunglassesPageConfig): {
  h1?: string;
  faq?: FaqItem[];
} {
  const primary = config.navigation.wap[0];
  const defaultSecondary =
    primary?.secondaryNav.find((s) => s.isDefault) || primary?.secondaryNav[0];
  return {
    h1: defaultSecondary?.h1,
    faq: defaultSecondary?.faq,
  };
}
